<template>
  <a @click="handleFacebookShare" class="img-a-button">
    <img src="@/assets/btn-facebook.png" alt="Share on facebook" />
  </a>
</template>

<script>
// Docs: https://developers.facebook.com/docs/sharing/reference/share-dialog
import { popupAtCenter } from "@/utils.js";
import { trackEvent } from "@/analytics";

export default {
  props: ["currentUser", "score", "referralUrl"],
  methods: {
    handleFacebookShare() {
      trackEvent("shared");
      const shareUrl = `https://www.facebook.com/sharer.php?t=Play & Win - A game of Snake&quote=Play Covve Snake with your friends and win!&u=${this
        .referralUrl || ""}`;
      popupAtCenter(shareUrl, "Share your score on Facebook", 600, 400);
    }
  }
};
</script>